import { DVString, Link, PaginatorItem } from './shared';
import { RequestContext } from '../../types/request-context';

export const CONTENT_TYPE_HELP_CONTENT = 'atv.wps#HelpContent'

export type HelpContent = {
  __type: typeof CONTENT_TYPE_HELP_CONTENT,
  content: string,
}

export interface HelpTopicLinks extends Link{
  applied: boolean
}

export type HelpPrimaryNav = {
  contactLink: Link,
  parentTitle?: string,
  rootLink: Link,
  searchPlaceholder: string,
  siblings: HelpTopicLinks[]
}

export type HelpSecondaryNav = {
  contactLink: Link,
  searchPlaceholder: string,
}

export type HelpDebug = {
  ignoreWeblabs?: boolean,
  ignoreConditions?: boolean,
  showConditions?: boolean,
  noHrefRewrite?: boolean
}
export interface HelpInput {
  context : RequestContext,
  topicID : string,
  debug? : HelpDebug,
  previewID? : string
}

export interface HelpOutput {
  landmark?: string,
  main: HelpContent,
  primaryNav?: HelpPrimaryNav,
  secondaryNav?: HelpSecondaryNav,
  title: string
}

export type HelpSearchResult = {
  breadcrumbs: Link[],
  summary: string,
  breadcrumbPrefix: string,
  title: Link
}

export type PaginationProps = {
  paginator: PaginatorItem[]
}

export interface HelpSearchInput {
  context: RequestContext,
  query: string,
  page: Number
}

export interface HelpSearchOutput {
  landmark: string,
  primaryNav: HelpPrimaryNav,
  results: HelpSearchResult[],
  summary: string,
  pagination?: PaginationProps,
  message?: DVString
}
